import { Injectable } from '@angular/core';
import { snackBarLeadIconMap } from '../models';
import { ISnackBarData } from '../models/snackbar-data.model';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  public snackbarData: ISnackBarData[] = [];

  public showMessage(type: ISnackBarData['type'], message: string, data?: Partial<ISnackBarData>): void {
    const snackbar: ISnackBarData = {
      type: type,
      message: message,
      config: {
        autoClose: type === 'critical' ? false : true,
        duration: data?.config?.duration || (type === 'success' ? 3000 : 0),
      },
      shouldDismissAfterAction: true,
      leadAdornmentConfig: {
        enabled: true,
        type: 'icon',
        size: 'large',
        iconName: snackBarLeadIconMap[type],
      },
      ...(data || {}),
    };
    if (type === 'critical') {
      snackbar.trailAdornmentConfig = {
        enabled: true,
        size: 'large',
        type: 'button',
        buttonConfig: {
          type: 'flat',
          color: 'neutral',
          label: 'OK',
          size: 'small',
        },
      };
    }
    this.snackbarData.push(snackbar);
  }
}
